import { render, staticRenderFns } from "./sidebar_extend_history.vue?vue&type=template&id=55061cfa&scoped=true&"
import script from "./sidebar_extend_history.vue?vue&type=script&lang=js&"
export * from "./sidebar_extend_history.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_extend_history.vue?vue&type=style&index=0&id=55061cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55061cfa",
  null
  
)

export default component.exports